// import { mock, fetch } from './fetch';
import { loadModules } from 'esri-loader';

const { 
    REACT_APP_BASE_URL_GIS_SERVER } = window['runConfig'];

export const getLengthBySizeDMA = (token, whereClause) => {

    let res = loadModules(["esri/request"], { css: true })
        .then(([esriRequest]) => {

            let baseURL = `${REACT_APP_BASE_URL_GIS_SERVER}`
            let url = `${baseURL}/server/rest/services/KELANTAN/KELANTAN_PIPELINES_V1/MapServer/2/Query`;

            const bodyFormData_getLengthBySizeDMA = new FormData();
            bodyFormData_getLengthBySizeDMA.set('f', 'json');
            const outStatistics = [{
                "statisticType": "sum",
                "onStatisticField": "SHAPE.STLength()/1000",
                "outStatisticFieldName": "LenghtOfMeterSize"
            }];
            bodyFormData_getLengthBySizeDMA.append('outStatistics', JSON.stringify(outStatistics));
            bodyFormData_getLengthBySizeDMA.append('groupByFieldsForStatistics', 'DMAID, TYPE, NOMINALDIAMETER');
            bodyFormData_getLengthBySizeDMA.append('outFields', 'DMAID, TYPE, NOMINALDIAMETER');
            bodyFormData_getLengthBySizeDMA.append('orderByFields', 'DMAID ASC, TYPE ASC, NOMINALDIAMETER ASC');

            bodyFormData_getLengthBySizeDMA.append('token', `${token}`);

            return esriRequest(url, {
                responseType: "json",
                body: bodyFormData_getLengthBySizeDMA,
            })
        });

    return res;
}